import { isIOS, isWeb } from "@memorang/helpers/platform";
import { useWindowDimensions } from "react-native";
import useBreakpoints from "./useBreakpoints";

export const useDevice = () => {
	const { smDown, smUp, lgUp, xxsDown, lgDown } = useBreakpoints();
	const { height } = useWindowDimensions();

	const isSmallScreen = xxsDown;
	const isMobile = smDown;
	const isMediumWindowSize = smUp && lgDown;
	const isLargeWindowSize = lgUp;
	const isIpad = isIOS && smUp;

	const isDesktopWeb = isWeb && !isMobile;
	const isMobileWeb = isWeb && isMobile;

	const isShortScreen = height < 900;

	return {
		isSmallScreen,
		isMobile,
		isMediumWindowSize,
		isLargeWindowSize,
		isIpad,
		isDesktopWeb,
		isMobileWeb,
		isShortScreen,
	};
};
